declare const Phaser: any;

export function createTextures(scene: any) {
  // Ship — blue triangle
  const shipGfx = scene.make.graphics({ add: false });
  shipGfx.fillStyle(0x3b82f6, 1);
  shipGfx.beginPath();
  shipGfx.moveTo(16, 0);
  shipGfx.lineTo(0, 32);
  shipGfx.lineTo(32, 32);
  shipGfx.closePath();
  shipGfx.fillPath();
  shipGfx.generateTexture("ship", 32, 32);
  shipGfx.destroy();

  // Bullet — green dot
  const bulletGfx = scene.make.graphics({ add: false });
  bulletGfx.fillStyle(0x10b981, 1);
  bulletGfx.fillCircle(3, 3, 3);
  bulletGfx.generateTexture("bullet", 6, 6);
  bulletGfx.destroy();

  // Asteroids — 3 sizes
  for (const { key, r } of [
    { key: "ast-lg", r: 24 },
    { key: "ast-md", r: 14 },
    { key: "ast-sm", r: 8 },
  ]) {
    const g = scene.make.graphics({ add: false });
    g.lineStyle(2, 0x9ca3af, 1);
    g.strokeCircle(r, r, r);
    g.generateTexture(key, r * 2, r * 2);
    g.destroy();
  }

  // Particle — white dot
  const particleGfx = scene.make.graphics({ add: false });
  particleGfx.fillStyle(0xffffff, 1);
  particleGfx.fillCircle(3, 3, 3);
  particleGfx.generateTexture("particle", 6, 6);
  particleGfx.destroy();
}
